import React, { useEffect, useState } from 'react'
import "./index.css";
import { Col, Row } from 'antd';
import dayjs from "dayjs";

const pad = (n) => String(n).padStart(2, "0");

function getCountdown(target) {
    const now = dayjs();
    const diff = target.diff(now);

    if (diff <= 0) {
        return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }

    const days = pad(Math.floor(diff / (1000 * 60 * 60 * 24)));
    const hours = pad(Math.floor((diff / (1000 * 60 * 60)) % 24));
    const minutes = pad(Math.floor((diff / (1000 * 60)) % 60));
    const seconds = pad(Math.floor((diff / 1000) % 60));

    return { days, hours, minutes, seconds };
}

export default function CountDown({ time }) {
    const [timeLeft, setTimeLeft] = useState(null);
    useEffect(() => {
        const interval = setInterval(() => {
            const result = getCountdown(time);
            setTimeLeft(result);
        }, 1000);
        return () => clearInterval(interval);
    }, [time])

    return <div className='countdown-outside-div'>
        <img src='/img/countdown-background-no-bg.png' width="100%" alt='countdown-background' />
        <Row className='countdown-div'>
            <Col span={6} className='countdown-col'
                style={{
                    fontFamily: "'Charm', cursive"
                }}>
                {timeLeft?.days}
                <div className='countdown-colon-div'>:</div>
            </Col>
            <Col span={6} className='countdown-col'
                style={{
                    fontFamily: "'Charm', cursive"
                }}>
                {timeLeft?.hours}
                <div className='countdown-colon-div'>:</div>
            </Col>
            <Col span={6} className='countdown-col'
                style={{
                    fontFamily: "'Charm', cursive"
                }}>
                {timeLeft?.minutes}
                <div className='countdown-colon-div'>:</div>
            </Col>
            <Col span={6} className='countdown-col'
                style={{
                    fontFamily: "'Charm', cursive"
                }}>
                {timeLeft?.seconds}
            </Col>
        </Row>
    </div>
}
